import { redo, undo } from 'prosemirror-history';
import { MenuItem } from 'prosemirror-menu';

export function historyMenu() {
  return [
    new MenuItem({
      title: 'Undo',
      run: state => undo(state),
      label: ' ',
      enable: state => undo(state),
      class: 'ProseMirror-icon-undo',
      css: undefined,
    }),
    new MenuItem({
      title: 'Redo',
      run: state => redo(state),
      label: ' ',
      enable: state => redo(state),
      class: 'ProseMirror-icon-redo',
      css: undefined,
    }),
  ];
}
